import { DefaultButton, Dropdown, Separator } from "@fluentui/react";
import styled, { keyframes } from "styled-components";
import { Link } from 'react-router-dom';
import { createGlobalStyle } from "styled-components";
import { Button } from "../../components/buttons/MainButton";

export const TitleCard = styled.div`
    padding: 0.5em 0.5em 0.5em 0.5em;
    flex-shrink: 0;
`;
export const ContainerCard = styled.div`
    min-height: 90px;
    background-color: ${props => props?.theme?.palette?.tertiary || "#e9eff1"};
    border-radius: 10px;
    width: 100%;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    
    @media(max-width: 768px)
    {
        min-height: 80px;
    }
    
    @media(max-width: 480px)
    {
        min-height: 70px;
    }
`;
export const IAContainerCard = styled.div`
    min-height: 90px;
    background-color: ${props => props?.theme?.palette?.tertiary || "#e9eff1"};
    border-radius: 10px;
    width: 100%;
    line-height: 16px;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    
    @media(max-width: 768px)
    {
        min-height: 80px;
    }
    
    @media(max-width: 480px)
    {
        min-height: 70px;
    }
`;
export const DataCard = styled.div`
    padding-top: 1.3em;
    font-size: 20px;
    float: right;
    padding-right: 8px;
    display: flex;
    width: 80%;
`;
export const DataCardContract = styled.div`
    padding: 0.5em 0.5em 0.5em 0.5em;
    min-height: 0;
    text-align: center;
`;
export const DataCardIA = styled.div`
    padding-top: 0.75em;
    font-size: 20px;
    float: right;
    padding-right: 5px;
    display: flex;
    width: 100%;
`;
export const TitleText = styled.h5`
    margin: 0;
    font-weight: 600;
    font-size: 1em;
    cursor: default;
    color: ${props => props?.theme?.palette?.primary || "#2A4143"};
    line-height: 1.2;
`;
export const DataText = styled.h5`
    padding-left: 1em;
    margin: 0 !important;
    width: 100%;
    text-align: end;
    font-size: 0.75em;
`;
// Texto aclaratorio bajo la cantidad de una tarjeta (p. ej. el precio fijo de los Elements Tierra)
export const FixedPriceText = styled.p`
    margin: 0.25em 0 0 0;
    text-align: right;
    font-size: 0.75em;
    cursor: default;
    color: ${props => props?.theme?.palette?.black || "#2A4143"};
    opacity: 0.75;
`;
export const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    display: inline-block;
    
    img
    {
        width: 24px;
        height: 24px;
        object-fit: contain;
    }
`;
export const ButtonContainer = styled.div`
    width: 85px;
    display: inline-block;

    button
    {
        width: 100%;
        height: 100%;
        min-height: 32px;
        display: inline-block;
    }
`;

export const DataTextContract = styled.h5`
    margin: 0 !important;
    text-align: right;
    font-size: 1.1em;
    font-weight: 600;
    cursor: default;
    color: ${props => props?.theme?.palette?.black || "#2A4143"};
    width: calc(100% - 50px);
    display: inline-block;
    padding-left: 0.5em;
    
    @media(max-width: 768px)
    {
        font-size: 1em;
        display: block;
        width: 90%;
    }
    
    @media(max-width: 480px)
    {
        font-size: 0.9em;
        padding-left: 0.25em;
    }
`;

export const DataTextContractIA = styled.h5`
    margin: 0 !important;
    text-align: right;
    font-size: 1.1em;
    font-weight: 600;
    cursor: default;
    color: ${props => props?.theme?.palette?.black || "#2A4143"};
    width: calc(100% - 100px);
    display: inline-block;
    padding-left: 0.5em;
    
    @media(max-width: 768px)
    {
        font-size: 1em;
        display: block;
        width: 90%;
    }
    
    @media(max-width: 480px)
    {
        font-size: 0.9em;
        padding-left: 0.25em;
    }
`;

export const FilterContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 1em;
    padding: 0 5px 0 0;

    > div span
    {
        border-radius: 15px;
    }
`;
export const ToggleContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${(props) => props.theme.palette.white};
    padding: 10px 12px;
    border-radius: 15px;
    border: 1px solid rgb(188, 200, 201);
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: ${(props) => props.theme.palette.lightBlack} !important;
`;
export const Shadow = styled.div`
    border-radius: 16px;
    padding: 48px;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 20px;
    min-height: 700px;
    max-height: 700px;
    background-color: ${props => props?.theme?.palette?.white};
    box-shadow: 0px 0px 16px rgb(8 84 117 / 8%);
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
`;
export const ShadowMargin10 = styled.div`
    border-radius: 16px;
    padding: 48px;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    min-height: 370px;
    background-color: ${props => props?.theme?.palette?.white};
    box-shadow: 0px 0px 16px rgb(8 84 117 / 8%);
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
`;
export const ShadowActivePromotions = styled.div`
    border-radius: 16px;
    padding: 48px 48px 0px 48px;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    min-height: 370px;
    background-color: ${props => props?.theme?.palette?.white};
    box-shadow: 0px 0px 16px rgb(8 84 117 / 8%);
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
`;
export const SubscribeButton = styled(DefaultButton)`
    background-color: #CC214F;
    color: white;
`;
export const DisabledButton = styled(DefaultButton)`
    background-color: grey;
    color: white;
`;
export const InfoSellCard = styled.div`
    background: #c0ced6;
    border-radius: 12px;
    color: black;
    padding: 1em;
    margin-bottom: 1em;
    line-height: 24px;
    display: inline-block;
    width: calc(100% - 30px);

    .ms-Grid-col
    {
        padding-left: 30px;
        img
        {
            margin-right: 10px;
        }
        h4
        {
            margin: 0;
            display: inline-block;
        }
        &:first-child
        {
            padding-left: 0;
        }
        button
        {
            margin-top: 14px;
        }
    }
    &:last-child
    {
        margin-bottom: 0;
    }
    .childrens
    {
        margin-top: 10px;
        padding-left: 0;
        .children
        {
            padding-top: 20px;
            margin-bottom: 10px;
            border-top: 1px solid white;
            padding-left: 30px;

            &:last-child
            {
                border-bottom: 1px solid white;
                padding-bottom: 10px;
            }
        }
    }
`;
export const ContractPanel = styled.div`
    background-color: ${props => props?.theme?.palette?.contractElementPanel};
    color: ${props => props?.theme?.palette?.black};
    width: 99%;
    padding: 1em 1em 1em 1em;
    border-radius: 10px;
    margin-top: 1em;
    max-height: 400px;
    overflow: auto;
    & hr
    {
        margin: 40px 0;
        border: solid 1px #e9eff2;
    }
`;
export const SignatureButton = styled(DefaultButton)``;
export const ContainerSignature = styled.div`
    grid-area: main;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
`;
export const HelperStyle = createGlobalStyle`
    *,
    ::after,
    ::before
    {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    } 
    ul
    {
        list-style-type: none;
    }
    a
    {
        text-decoration: none;
    }
`;
export const MainContainerSignature = styled.div`
    padding: 1em 1em;
`;
export const ModalMainCont = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 430px;
    border-radius: 15px;
    background-color: #ffffff;
    z-index: 150;
    padding: 40px;
    & hr
    {
        margin: 25px 0 25px 0;
        border: solid 1px #E9EFF2;
    }
`;
export const ModalIAMainCont = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 430px;
    border-radius: 15px;
    background-color: #ffffff;
    z-index: 150;
    padding: 2.5rem;
    font-size: 18px;
`;
export const ModalFocus = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: ${(props) => // @ts-ignore
            props.height};
    background-color: #2a414380;
    z-index: 100;
`;
export const ModalToExitCont = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
`;
export const ModalToExit = styled.div`
    position: relative;
    & i
    {
        &:hover
        {
            cursor: pointer;
        }
    }
`;
export const ModalContinue = styled.h3`
    font-size: 20px !important;
    font-weight: 800;
    color: #2A4143;
    margin-top: -20px !important;
    font-weight: 700 !important;
    word-spacing: -1px;
`;
export const ModalNeedsCont = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    &p
    {
        font-size: 15px;
        font-weight: 500;
        color: #6a7a7c;
        margin-bottom: 25px;
    }
`;
export const ModalCompletedIcon = styled.img`
	display: block;
	width: 50px;
	height: 50px;
    margin-bottom: 40px;
    margin-top: -20px;
`;
export const ModalBtnCont = styled.div`
    display: flex;
    float: right;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 20px;
`;
export const ModalAcceptBtn = styled.button`
    display: block;
    border: none;
    border-radius: 20px;
    width: 160px;
    height: 45px;
    background-color: #cc214f;
    font-family: inherit;
    color: #ffffff;
    font-weight: 500;
    &:hover
    {
        cursor: pointer;
    }
`;
export const ModalLinkBtn = styled(Link)`
    display: block;
    width: fit-content;
`;
// Contenedor principal flex para todas las tarjetas
export const ElementsContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: stretch;
    flex-wrap: wrap;
    min-height: 80px;
    margin-top: 5px;
    width: 100%;
    justify-content: space-between;
    
    @media(max-width: 768px)
    {
        gap: 8px;
    }
    
    @media(max-width: 480px)
    {
        gap: 5px;
    }
`;

// Contenedor flex para las 4 tarjetas de elementos
export const ElementsCardsContainer = styled.div`
    display: flex;
    gap: 8px;
    min-width: 0;
    width: 75%;
    flex: 0 0 auto;
    
    @media(max-width: 768px)
    {
        gap: 6px;
        max-width: 70%;
    }
    
    @media(max-width: 480px)
    {
        gap: 4px;
        max-width: 80%;
    }
`;

// Contenedor individual para cada tarjeta de elemento
export const ElementCardWrapper = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
`;

// Contenedor para la tarjeta de IA
export const IACardWrapper = styled.div`
    flex: 0 0 auto;
    min-width: 200px;
    display: flex;
    margin-left: auto;
    
    @media(max-width: 768px)
    {
        min-width: 130px;
        max-width: 180px;
    }
    
    @media(max-width: 480px)
    {
        min-width: 120px;
        max-width: 160px;
    }
`;

export const DivColIAItem = styled.div``;
export const DivColButtonIA = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
`;
export const TitleIAText = styled.h4`
    cursor: default;
    margin: 0 !important;
    padding-left: 0.5em;
`;
export const LogoIA = styled.img`
    padding-top: 0.25em;
`;
export const DivColLogoIA = styled.div`
    margin-top: 0.5em;
    text-align: end;
`;
export const DataIAText = styled.h5`
    width: 100%;
    margin: 0 !important;
    text-align: end;
    font-size: 1em;
    cursor: default; 
`;
export const DivColTitle = styled.div``;
export const ButtonBuyElements = styled.button`
    border: 0px;
    border-radius: 24px;
    background-color: #CC214F;
    color: white;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 0.9em;
    font-weight: 600;
    white-space: nowrap;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover
    {
        background-color: #B01E45;
    }
`;

//---------------ELEMENTS IA------------------------//
export const MainTitle = styled.h2`
    cursor: default;
    margin-top: 0;
    margin-bottom: 0.5em;
`;
export const MainDescription = styled.p`
    margin: 0;
    color: #556769;
    cursor: default;
`;
export const MainElementsDescription = styled.p`
    margin: 0;
    cursor: default;
`;
export const RowBody = styled.div`
    margin-bottom: 3em;
`;
export const RowWaterElements = styled.div`
    margin-bottom: 1em;
`;
export const ColImageWaterIcon = styled.div`
    text-align: center;
    @media (min-width: 480px) and (max-width: 639.99px)
    {
        margin-top: 4px;
    }
    @media (min-width: 640px) and (max-width: 1023.99px)
    {
        margin-top: 10px;
    }
    @media (min-width: 1024px) and (max-width: 1365.99px)
    {
        margin-top: 8px;
    }
`;
export const DivSMAuxiliarRow = styled.div`
`;
export const DivSMAuxiliarRow2 = styled.div`
    padding-top: 1em;
`;
export const ColElementsDescription = styled.div`
    margin-top: 6px;

    @media (min-width: 320px) and (max-width: 479.99px)
    {
        margin-top: 0;
    }
`;
export const ElementsWater = styled.p`
    margin: 0;
    cursor: default;
`;
export const ColElementsInput = styled.div`
    text-align: center;
`;
export const InputWaterElements = styled.input`
    width: 75%;
    height: 25px;
    border: 1px solid black;
    text-align: end;
    border-color: #CC214F;
`;
export const ColElementsUsingButton = styled.div``;
export const ButtonUseElements = styled.button`
    border: 0px;
    border-radius: 24px;
    background-color: #CC214F;
    color: white;
    width: 100%;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 1px;
    cursor: pointer;

    @media (min-width: 320px) and (max-width: 479.99px)
    {
        width: 100%;
    }
`;
export const ColRestoreElements = styled.div`
`;
export const ButtonRestoreElements = styled.button`
    border: 0px;
    border-radius: 24px;
    background-color: #CC214F;
    color: white;
    width: 100%;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 1px;
    cursor: pointer;

    @media (min-width: 320px) and (max-width: 479.99px)
    {
        width: 80%;
    }
`;
export const ColDataOrder = styled.div``;
export const DivCardOrder = styled.div`
    border-radius: 1.5em !important;
    background: #F3F7F9 !important;
    padding: 1em 1em 2em 2em;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #556769;
`;
export const DlOrder = styled.dl`
    margin: 0 !important;
`;
export const DtOrder = styled.dt``;
export const DdOrder = styled.dd``;
export const UlOrder = styled.ul``;
export const LiOrder = styled.li``;
export const DtReference = styled.dt``;
export const DdReference = styled.dd``;
export const DtImporte = styled.dt``;
export const DdImporte = styled.dd``;
export const ColFormPayment = styled.div``;
export const FormPaymentCard = styled.div`
    cursor: default;
    background: rgb(255, 255, 255);
    box-shadow: 0 0 5px 3px rgb(0 0 0 / 8%);
    border-radius: 16px;
    font-family: Barlow;
    position: relative;
    width: 100%;
    height: auto;
    display: inline-block;
    overflow: hidden;
    padding: 1em 1em 1.95em 0.25em;
`;
export const DivPayment = styled.div`
    margin: 0;
    padding: 0 0 0 1em;
    border-radius: 0.75em;
`;
export const DivColActivePlan = styled.div`
    padding-left: 1em;
`;
export const ContainerActivePlanText = styled.div`
    margin-top: 1.3em;
    padding-left: 0.75em;
`;
export const DivColDropdownActivePlan = styled.div`
    padding-left: 1em;
    padding-top: 0.5em;
`;
export const DropdownActivePlan = styled(Dropdown)`
    min-width: 180px;
    flex: 1;
    height: 36px !important;

    .ms-Dropdown
    {
        height: 36px !important;
    }
    
    .ms-Dropdown-title
    {
        height: 36px !important;
        padding: 0 12px;
        display: flex;
        align - items: center;
    }

    &&.ms-Checkbox.ms - Dropdown - item.dropdown - 133 label.ms - Checkbox - label.label - 135,
    &&.ms-Checkbox label,
    &&.ms-Checkbox.ms-Checkbox-label,
    &&.ms-Checkbox.is-enabled label,
    &&.ms-Checkbox.is-enabled.ms-Checkbox-label
    {
        color: ${props => props?.theme?.palette?.neutralPrimary || '#000000'} !important;
    }

    .ms-Dropdown-title
    {
        border-color: #CC214F !important;
    }

    .ms-Dropdown-caretDownWrapper
    {
        margin-top: -1px !important;
        color: #CC214F !important;
    }

    .ms-Checkbox-checkbox
    {
        border-color: #CC214F !important;
            
        &.is-checked
        {
            background-color: #CC214F !important;
        }
    }

    &:hover.ms-Dropdown-title
    {
        border-color: #CC214F !important;
    }

    &:focus.ms-Dropdown-title
    {
        border-color: #CC214F !important;
    }

    .ms-Dropdown-multiSelectItem
    {
        background-color: #CC214F !important;
        color: white !important;
    }

    &.is-disabled, &[disabled]
    {
        .ms-Dropdown-title
        {
            background-color: ${props => props?.theme?.palette?.neutralLighter || 'white'} !important;
            border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
            cursor: not-allowed !important;
        }

        .ms-Dropdown-caretDownWrapper
        {
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        }

        &:hover.ms-Dropdown-title
        {
            border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        }
    }
`;
export const DivRowForm = styled.div``;
export const DivColDisclaimer = styled.div`
    padding-left: 1em;
    padding-top: 1em;
    padding-bottom: 2em;
`;
export const DivColImageIA = styled.div`
    text-align: center;

    @media (min-width: 320px) and (max-width: 1249.99px)
    {
        padding-top: 0.5em;
    }
`;
export const ImageIA = styled.img`
`;
export const DivColText = styled.div`
`;
export const InfoText = styled.p`
    margin: 0;
    padding-left: 0;
    padding-bottom: 1em;
    cursor: default;
    text-align: justify;
`;
export const DivColBuyElements = styled.div`
    padding-left: 1em;
    padding-top: 1em;
`;
export const InputSubmitElements = styled.input`
    width: 100%;
    height: 25px;
    border: 1px solid #CC214F;
    text-align: end;
    border-radius: 8px;
`;
export const DivColButtonSubmit = styled.div`
    text-align: end;
    padding-top: 1em;
`;
export const WarningContainer = styled.div`
    display: flex;
    flex-direction: column;
    cursor: default;
    background: ${(props) => props.theme.palette.warnSecondary};
    color: ${(props) => props.theme.palette.warn};
    padding: 1em;
    text-align: justify;
    gap: 10px;
    font-weight: 500;
    h3
    {
        margin: 0;
    }
    p
    {
        line-height: 20px;
        margin: 0;
    }
`;
export const WarningText = styled.p`
    margin: 0 !important;
    font-size: 13px !important;
    line-height: 15px !important;
`;
export const DivRowButtonSubmit = styled.div``;
export const DivSpinner = styled.div``;
export const DivTextButton = styled.div``;
export const DivTextButtonNoSpinner = styled.div`
    padding: 0;
`;
export const ButtonSubmit = styled.button`
    display: inline-block;
    background: #CC214F;
    box-shadow: 0px 0px 16px rgba(8,84,117,0.08);
    color: #FFFFFF;
    font-family: Barlow;
    font-weight: 600 !important;
    padding: 3px 20px !important;
    max-width: 100%;
    box-sizing: content-box;
    border: 2px solid #CC214F;
    border-radius: 100px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;

    &:disabled
    {
        background: #E0E0E0;
        border: 2px solid #E0E0E0;
        color: #A6A6A6;
        cursor: not-allowed;
        box-shadow: none;
    }
`;
export const DivProcessPayment = styled.div`
    padding-left: 1em;
    padding-top: 2.5em;
    padding-bottom: 0.5em;
    text-align: end;
`;
export const ProcessPayment = styled.p`
    margin: 0;
    cursor: default;
    font-size: 11px;
`;
export const ErrorBarCol = styled.div``;
export const ErrorText = styled.p`
    margin: 0;
    font-size: 18px;
    color: red;
    padding-left: 1em;
    cursor: default;
`;
export const RowInfo = styled.div`
    padding-top: 1em;
`;
export const ColInfoTitle = styled.div``;
export const InfoTitle = styled.h1`
    cursor: default;
    margin-top: 0;
    margin-bottom: 0;
    color: ${props => props.theme.palette.black};
`;
export const ColInfoSubTitle = styled.div``;
export const InfoSubTitle = styled.h4`
    cursor: default;
    color: ${props => props.theme.palette.black};
    font-weight: 350;
    margin-top: 1rem;
    margin-bottom: 1rem;
`;
export const ColCards = styled.div``;
export const RowInsideCards = styled.div``;
export const ColFirstCard = styled.div`
    padding-bottom: 1em;
`;
export const ColSecondCard = styled.div`
    padding-bottom: 1em;
`;
export const ColThirdCard = styled.div`
    padding-bottom: 1em;
`;
export const Card = styled.div`
    cursor: default;
    background: rgb(255, 255, 255);
    box-shadow: 0 0 5px 3px rgb(0 0 0 / 8%);
    border-radius: 16px;
    font-family: Barlow;
    position: relative;
    width: 100%;
    height: auto;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 1em;
    @media (min-width: 1366px)
    {
        min-height: 315px;
    }
`;
export const CardTitle = styled.div`
    width: 100%;
    padding: 1em 0 1em 0;
    color: ${(props) => props.theme.palette.black};
    background: ${(props) => props.theme.palette.cardFooter};
`;
export const TitleCardText = styled.p`
    margin-top: 0;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    padding-left: 1em;
    padding-right: 0.75em;
    text-overflow: ellipsis;
    overflow-x: hidden;
`;
export const CardBody = styled.div`
    padding-top: 0.5em;
`;
export const BodyCardText = styled.p`
    margin: 0;
    cursor: default;
    padding-left: 1em;
    padding-right: 1.5em;
    text-align: justify;
    color: ${props => props.theme.palette.allBlack};
`;
export const RowButtonGetMoney = styled.div`
    padding-left: 1em;
    @media (min-width: 640px)
    {
        padding-right: 1em;
    }
`;
export const ColButtonTextGetMoney = styled.div``;
export const ColButtonGetMoney = styled.div``;
export const TextGetMoney = styled.p`
    color: ${props => props.theme.palette.allBlack};
    margin-top: 1.5em;
`;
export const ButtonGetMoney = styled.button`
    border: 1px solid #CC214F;
    border-radius: 20px;
    background-color: #CC214F;
    color: white;
    cursor: pointer;
    margin-top: 10px;
    padding: 0.75em 1em 0.75em 1em;
    width: 100%;
`;
export const RowContract = styled.div`
    padding-top: 1em;
    padding-left: 1em;
    @media (min-width: 640px)
    {
        padding-right: 1em;
    }
`;
export const ColContractText = styled.div``;
export const ContractText = styled.p`
    padding-right: 0.5em;
    margin-top: 0;
    margin-bottom: 0;
    color: ${props => props.theme.palette.allBlack};
`;
export const ColContractButton = styled.div`
    text-align: end;
    padding-right: 0.5em;
    padding-top: 0.5em;
`;
export const ButtonContract = styled.button`
    border: 1px solid #E0E0E0;
    border-radius: 20px;
    background-color: #E0E0E0;
    color: black;
    cursor: not-allowed;
    padding: 0.75em 1em 0.75em 1em;
    width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
`;

///ElementIATransfer

export const IATransferMain = styled.main`
    display: flex;
    flex-direction: column;
    padding-bottom: 2em;
    width: 100%;
    margin: 0;

    .button-spinner
    {
        float: left;
        margin-right: 10px;
    }
    & .restarted-ms-Grid > .ms-Grid-row
    {
        margin: 0 -24px !important;

        & > .ms-Grid-col
        {
            padding-left: 24px;
            padding-right: 24px;
        }
    }
    & .ms-Stack .ms-StackItem
    {
        width: 100%;
    }
    & .ms-Stack .ms-StackItem,
    & .investment-fund-finder .ms-ComboBox-container
    {
        margin-top: 1px;
    }
    & .ms-Stack .ms-StackItem:first-child, .investment-fund-finder .ms-ComboBox-container:first-child
    {
        margin-top: 0;
    }
    & .ms-Stack .ms-StackItem:not(:first-child)
    {
        margin-left: 0;
    }
    & .ms-ChoiceField
    {
        display: inline-flex;
        margin-right: 8px;
        background: ${props => props?.theme?.palette?.white || "#FFF"};
        border: 1px solid ${props => props?.theme?.palette?.neutralLighter || "#E9EFF1"};
        padding: 10px 16px;
        border-radius: 26px;
    }
`;
export const IASeparatorTop = styled(Separator)`
    margin-bottom: 1em;
`;
export const IASeparatorForm = styled(Separator)`
    margin-top: 17px;
    margin-bottom: 17px;
`;
export const IATitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: default;
    h2
    {
        margin: 0;
        cursor: default;
    }
`;
export const IACard = styled.div`
    cursor: default;
    background: rgb(255, 255, 255);
    box-shadow: 0 0 5px 3px rgb(0 0 0 / 8%);
    border-radius: 16px;
    font-family: Barlow;
    position: relative;
    width: 100%;
    height: auto;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 1em;
`;
export const IACardContainer = styled.div`
    background-color: ${props => props?.theme?.palette?.tertiary || "#F3F7F9"};
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    padding: 25px 30px 25px 30px;
    height: auto;
`;
export const IACardHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 1 0;
    justify-content: center;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    h3
    {
        margin: 0;
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
    }

    .small-text
    {
        margin-top: 6px;
    }
`;
export const IATitleCardText = styled.p`
    margin-top: 0;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    padding-left: 1em;
    padding-right: 0.75em;
    text-overflow: ellipsis;
    overflow-x: hidden;
    text-align: left;
`;
export const IACardHeadingContainer = styled.div`
    cursor: default;
`;
export const IACardBody = styled.div`
    margin-top: 0;
    padding-top: 0.5em;
    padding-left: 1em;
    padding-right: 1.5em;
    text-align: justify;
`;
export const IAInformText = styled.div`
    margin-bottom: 24px;
    padding: 16px;
    background-color: ${props => props?.theme?.palette?.white};
    border-radius: 8px;
    border-left: 4px solid #0078d4;
    border-right: 4px solid #0078d4;
    cursor: default;
`;
export const IAText = styled.p`
    font-size: 18px;
    line-height: 20px;
    cursor: default;
    color: ${props => props?.theme?.palette?.lightBlack};
    margin-top: 0;
    margin-bottom: 0;
`;
export const IAAdvertisedText = styled.p`
    font-size: 18px;
    line-height: 20px;
    cursor: default;
    color: ${props => props?.theme?.palette?.black || "#eefdff"};
    margin-top: 0;
    margin-bottom: 0;
`;
export const IANoPlansText = styled.div`
    padding: 20px;
    text-align: center;
    color: #666;
    cursor: default;
`;
export const IARefundTextContainer = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 1em;
`;
export const IARefundButtonReveal = styled.button`
    position: absolute;
    right: 8px;
    top: 34px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: ${props => props?.theme?.palette?.themePrimary || "#0078d4"};
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    zIndex: 1
`;
export const IATextSmall = styled.p`
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    margin: 0;
    cursor: default;
    margin-top: 2em;
    color: ${props => props?.theme?.palette?.neutralText || "#95A0A1"};
`;
export const IAContainerButton = styled.div`
    text-align: end;
`;
export const IACardButton = styled(Button.Primary)`
    margin-top: 1.5em;
    margin-bottom: 0px;
    padding: 0.75rem 2rem !important;
`;
export const IADisabledCardButton = styled(Button.Primary)`
    margin-top: 1.5em;
    margin-bottom: 0px;
    padding: 0.75rem 2rem !important;
    background-color: #556769 !important;
    cursor: not-allowed !important;
`;
export const IACardTitle = styled.div`
    width: 100%;
    padding: 1em 0 1em 0;
    color: ${(props) => props.theme.palette.black};
    background: ${(props) => props.theme.palette.cardFooter};
`;
export const IATransferForm = styled.div``;
export const IAInfoForm = styled.div`
    padding-bottom: 1em;
    
    @media (max-width: 1023.50px)
    {
        padding-top: 1em;
    }
`;
export const IACustomSeparator = styled(Separator)`
    ::before
    {
        background-color: #8c9192;
    }
`;

export const IASavingPlansTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: ${props => props?.theme?.palette?.themePrimary || "#0078d4"};
    margin: 20px 0 15px 0;
    text-align: left;
    cursor: default;
`;

export const IASavingPlanContainer = styled.div<{hasContractSigned: boolean; elementAmount: number}>`
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #e1e1e1;
    border-radius: 8px;
    background-color: ${props =>
    {
        const {hasContractSigned, elementAmount} = props;
        
        // Contrato firmado y tiene Elements IA - Normal
        if(hasContractSigned && elementAmount > 0)
        {
            return props?.theme?.palette?.white || "#ffffff";
        }
        
        // Contrato firmado pero sin Elements IA (incluyendo casos en los que pudieramos tener valores negativos) - Color rosa claro
        if(hasContractSigned && elementAmount <= 0)
        {
            return "#F9F5F6";
        }
        
        // Contrato no firmado pero tiene Elements IA suficientes
        if(!hasContractSigned && elementAmount > 0)
        {
            console.log("Caso 3: Contrato no firmado + Elements IA > 0 - Fondo rosa medio");
            return "#F1E7EB";
        }
        
        // Contrato no firmado y sin Elements IA (incluyendo valores negativos) - Color oscuro
        if(!hasContractSigned && elementAmount <= 0)
        {
            return "#634353";
        }
        
        return props?.theme?.palette?.white || "#ffffff";
    }};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
`;

export const IASavingPlanCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const IASavingPlanHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    cursor: default;
`;

export const IASavingPlanNameContainer = styled.div`
    flex: 0 0 70%;
    min-width: 0;
`;

export const IASavingPlanContractStatusContainer = styled.div`
    flex: 0 0 30%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const IASavingPlanName = styled.h4<{hasContractSigned: boolean; elementAmount: number}>`
    margin: 0;
    color: ${props => getTextColor(props.hasContractSigned, props.elementAmount, props.theme)};
    font-size: 18px;
    font-weight: 600;
`;

export const IASavingPlanContractStatus = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 16px;
    font-weight: 500;
`;

export const IASavingPlanContractSigned = styled.span`
    color: #28a745;
`;

export const IASavingPlanContractNotSigned = styled.span`
    color: #dc3545;
`;

export const IASavingPlanRow = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
`;

export const IASavingPlanAccountsRow = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
`;

export const IASavingPlanDropdownContainer = styled.div`
    flex: 1;
`;

export const IASavingPlanAmountRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    flex-wrap: wrap;
    min-height: 50px;
    cursor: default;
`;

export const IASavingPlanAmountLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 4em;
    flex: 1;
`;

export const IASavingPlanAmountRight = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;

export const IASavingPlanInputContainer = styled.div`
    flex: 1;
    max-width: 300px;
    display: flex;
    align-items: center;
`;

export const IASavingPlanInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
`;

export const IASavingPlanInputRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const IASavingPlanInputLabel = styled.label<{hasContractSigned: boolean; elementAmount: number}>`
    font-size: 14px;
    font-weight: 600;
    color: ${props => getTextColor(props.hasContractSigned, props.elementAmount, props.theme)};
    white-space: nowrap;
    flex-shrink: 0;
`;

export const IASavingPlanInput = styled.input<{hasContractSigned: boolean; elementAmount: number}>`
    flex: 1;
    height: 32px;
    padding: 0 8px;
    border: 1px solid ${props => props?.theme?.palette?.neutralQuaternary || "#d2d0ce"};
    border-radius: 2px;
    font-size: 14px;
    font-family: inherit;
    background-color:
        ${props => props?.disabled 
        ? props?.theme?.palette?.neutralLighter || "#f3f2f1"
        : props?.theme?.palette?.white || "#ffffff"
    };
    color: ${props => props?.disabled 
        ? props?.theme?.palette?.neutralTertiary || "#a19f9d"
        : getTextColor(props.hasContractSigned, props.elementAmount, props.theme)
    };
    transition: border-color 0.15s ease-in-out;
    cursor: ${props => props?.disabled ? "not-allowed" : "text"};
    
    &:focus
    {
        outline: none;
        border-color: ${props => props?.theme?.palette?.themePrimary || "#CC214F"};
        box-shadow: 0 0 0 1px ${props => props?.theme?.palette?.themePrimary || "#CC214F"};
    }
    
    &::placeholder
    {
        color: ${props =>
        {
            // Para fondos oscuros, usar placeholder más claro
            if(!props.hasContractSigned && props.elementAmount <= 0)
            {
                return "#CCCCCC"; // Fondo oscuro - placeholder claro
            }
            // Para fondos claros, usar placeholder normal
            return props?.theme?.palette?.neutralSecondary || "#605e5c";
        }};
    }
    
    &:disabled
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || "#f3f2f1"};
        color: ${props => props?.theme?.palette?.neutralTertiary || "#a19f9d"};
        cursor: not-allowed;
    }
`;

export const IASavingPlanInputError = styled.span`
    font-size: 12px;
    color: ${props => props?.theme?.palette?.red || "#d13438"};
    margin-top: 2px;
`;

export const IASavingPlanElementsInfo = styled.div<{hasContractSigned: boolean; elementAmount: number}>`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    color: ${props => getTextColor(props.hasContractSigned, props.elementAmount, props.theme)};
`;

export const IASavingPlanElementsIcon = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 12px;
    flex-shrink: 0;
`;
export const IAElementsIAIcon = styled.img``;

export const IASavingPlanActionsRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
`;

export const IASavingPlanIncludeButton = styled.button`
    background: transparent;
    border: 1px solid ${props => props?.theme?.palette?.themePrimary || "#0078d4"};
    color: ${props => props?.theme?.palette?.themePrimary || "#0078d4"};
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &:hover
    {
        background-color: ${props => props?.theme?.palette?.themePrimary || "#0078d4"};
        color: white;
    }
    
    &:disabled
    {
        opacity: 0.5;
        cursor: not-allowed;
        background-color: #f5f5f5;
        color: #999;
        border-color: #ddd;
    }
`;

export const IASavingPlanSignButton = styled.button`
    background-color: ${props => props?.theme?.palette?.themePrimary};
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 12px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &:hover
    {
        background-color: ${props => props?.theme?.palette?.themeDark || "#005a9e"};
    }
`;

export const IASavingPlanCheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${props => props?.theme?.palette?.black || "#333333"};
`;

export const IASavingPlanCheckbox = styled.input`
    width: 16px;
    height: 16px;
    cursor: pointer;
    flex-shrink: 0;
    
    &:disabled
    {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const IASavingPlanCheckboxLabel = styled.label`
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    
    &:disabled
    {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;
export const IASignatureForm = styled.div`
    padding-top: 2em;
    padding-left: 2em;
    padding-right: 2em;
`;
const changeColor = keyframes`
    0%
    {
        color: black;
    }
    50%
    {
        color: #CC214F;
    }
    100%
    {
        color: black;
    }
`;
export const IAProcessingLoadingText = styled.p`
    cursor: default;
    padding-left: 1em;
    padding-top: 1em;
    font-size: 15px;
    font-weight: 700;
    animation: ${changeColor} 1.5s infinite;
`;

// Función helper para determinar el color de texto basado en el estado
const getTextColor = (hasContractSigned: boolean, elementAmount: number, theme: any) =>
{
    // Contrato firmado y tiene Elements IA - Normal (fondo blanco)
    if(hasContractSigned && elementAmount > 0)
    {
        return theme?.palette?.black || "#323130";
    }
    
    // Contrato firmado pero sin Elements IA (fondo rosa claro)
    if(hasContractSigned && elementAmount <= 0)
    {
        return theme?.palette?.black || "#323130";
    }
    
    // Contrato no firmado pero tiene Elements IA (fondo rosa medio)
    if(!hasContractSigned && elementAmount > 0)
    {
        return theme?.palette?.allBlack;
    }
    
    // Contrato no firmado y sin Elements IA (fondo oscuro)
    if(!hasContractSigned && elementAmount <= 0)
    {
        return "#FFFFFF";
    }
    
    // Fallback
    return theme?.palette?.black || "#323130";
};

// Botón para eliminar plan de ahorro
export const IASavingPlanRemoveButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #d2d0ce;
    border-radius: 4px;
    background-color: white;
    color: #605e5c;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    
    &:hover
    {
        background-color: #f3f2f1;
        border-color: #a19f9d;
        color: #323130;
    }
    
    &:active
    {
        background-color: #edebe9;
        border-color: #8a8886;
    }
    
    &:focus
    {
        outline: none;
        border-color: #0078d4;
        box-shadow: 0 0 0 1px #0078d4;
    }
`;

// Texto para contrato firmado en la tercera fila
export const IASavingPlanContractSignedText = styled.div`
    color: ${props => props?.theme?.palette?.green || "#107c10"};
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    background-color: ${props => props?.theme?.palette?.greenLight || "#f3f9f3"};
    border-radius: 4px;
    border: 1px solid ${props => props?.theme?.palette?.green || "#107c10"};
`;

// Modal de validación de reembolsos Elements IA
export const IAModalValidationContainer = styled.div`
    padding: 20px;
`;

export const IAModalValidationTitle = styled.h2`
    margin: 0 0 20px 0;
    color: ${props => props?.theme?.palette?.neutralPrimary || "#323130"};
    font-size: 24px;
    font-weight: 600;
    cursor: default;
`;


export const IAModalValidationSection = styled.div`
    margin-bottom: 20px;
`;

export const IAModalValidationSectionTitle = styled.h3`
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 600;
`;

export const IAModalValidationSectionTitleError = styled(IAModalValidationSectionTitle)`
    color: #d13438;
`;

export const IAModalValidationSectionTitleSuccess = styled(IAModalValidationSectionTitle)`
    color: #107c10;
`;

export const IAModalValidationList = styled.ul`
    margin: 0;
    padding-left: 20px;
`;

export const IAModalValidationListItem = styled.li`
    margin-bottom: 5px;
    color: ${props => props?.theme?.palette?.neutralPrimary || "#323130"};
    font-size: 14px;
`;

export const IAModalValidationPlanContainer = styled.div`
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f8f8f8;
    border-radius: 4px;
    border-left: 4px solid #d13438;
`;

export const IAModalValidationPlanName = styled.strong`
    color: ${props => props?.theme?.palette?.neutralPrimary || "#323130"};
    font-size: 14px;
    font-weight: 600;
`;

export const IAModalValidationPlanErrorsList = styled.ul`
    margin: 5px 0 0 0;
    padding-left: 20px;
`;

export const IAModalValidationPlanErrorItem = styled.li`
    margin-bottom: 3px;
    color: #d13438;
    font-size: 13px;
`;

export const IAModalValidationButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
`;

// Texto informativo para el modal de validación
export const IAModelValidationPreviousText = styled.p`
    margin: 0 0 20px 0;
    color: ${props => props?.theme?.palette?.neutralSecondary || "#605e5c"};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
`;

// Contenedor para el estado de procesamiento
export const IAProcessingStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
`;

export const IAProcessingStateText = styled.p`
    margin: 16px 0 0 0;
    color: ${props => props?.theme?.palette?.neutralPrimary || "#323130"};
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
`;

export const IAProcessingStateSubText = styled.p`
    margin: 8px 0 0 0;
    color: ${props => props?.theme?.palette?.neutralSecondary || "#605e5c"};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
`;